import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { useSmoothApi } from "../useSmoothApi"
import useSWR from "swr"
import { camelCase } from "src/lib/aikagi"

type Contract = {
  id: number
  contractedOn: string
  disabled: string
  enabled: boolean
  interestAmount: number
  interestRate: number
  loan: number
  numberOfPayment: number
  paidAmount: number
  reimbursedOn: string
  status: string
  version: number
  createdAt: string
  updatedAt: string
  agreedAt?: string // 賃貸借契約締結日 (date型)
}

export const useProposalsContractSWR = (proposalId: number) => {
  const { getWithToken } = useSmoothApi()
  const url = SMOOTH_SMOOTHER_API_URL + "/proposals/" + proposalId + "/contract"

  const fetcher = async () => {
    const res = await getWithToken(url)

    if (res.data && res.data.contracts && res.data.contracts.length > 0) {
      return camelCase(res.data.contracts[0]) as Contract
    }

    // 元のコードとの互換性を保つため、contractがある場合はそれを返す
    if (res.data && res.data.contract) {
      return camelCase(res.data.contract) as Contract
    }

    return null
  }

  const swr = useSWR(proposalId ? url : null, fetcher)

  return swr
}
